// extracted by mini-css-extract-plugin
export var dark = "r_sj";
export var darkcookie = "r_sk";
export var tintedcookie = "r_sl";
export var regularcookie = "r_sm";
export var darkbase = "r_sn";
export var tintedbase = "r_sp";
export var regularbase = "r_sq";
export var darkraw = "r_sr";
export var tintedraw = "r_ss";
export var regularraw = "r_st";
export var darkchick = "r_sv";
export var tintedchick = "r_sw";
export var regularchick = "r_sx";
export var darkherbarium = "r_sy";
export var tintedherbarium = "r_sz";
export var regularherbarium = "r_sB";
export var darkholiday = "r_sC";
export var tintedholiday = "r_sD";
export var regularholiday = "r_sF";
export var darkoffline = "r_sG";
export var tintedoffline = "r_sH";
export var regularoffline = "r_sJ";
export var darkorchid = "r_sK";
export var tintedorchid = "r_sL";
export var regularorchid = "r_sM";
export var darkpro = "r_sN";
export var tintedpro = "r_sP";
export var regularpro = "r_sQ";
export var darkrose = "r_sR";
export var tintedrose = "r_sS";
export var regularrose = "r_sT";
export var darktimes = "r_sV";
export var tintedtimes = "r_sW";
export var regulartimes = "r_sX";
export var darkwagon = "r_sY";
export var tintedwagon = "r_sZ";
export var regularwagon = "r_s0";